'use strict';

export class ReportStatusCtrl
{
	$scope;
	$mdDialog;
	$filter;
	$timeout;
	cfg;
	cfgPausePaymentDealine;
	jsDataService;


	constructor($scope, jsDataService, $mdDialog, $filter, $timeout){
		'ngInject';
		this.$scope = $scope;
		this.$mdDialog = $mdDialog;
		this.$filter = $filter;
		this.$timeout = $timeout;
		this.cfg = jsDataService.get('cfgReportStatus', {});
		this.cfgPausePaymentDealine = jsDataService.get('cfgPausePaymentDeadline', {});
		this.jsDataService = jsDataService;
	}

	changeStatus(ev){

		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "jsDataService", "cfg", this.dialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'projects/ng_status.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: true,
			locals: {
				cfg: this.cfg
			}
		}).then((results) => {
			if(this.cfg.submitUrl){
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.submitUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}

	dialogCtrl($scope, $mdDialog, jsDataService, cfg){
		const classif = jsDataService.get('cfgClassif', {});
		if(typeof(cfg.classifId) === 'undefined'){
			cfg.classifId = 'periodic_report_status';
		}
		$scope.dialogTitle = cfg.dialogTitle;
		$scope.fieldTitle = cfg.fieldTitle;
		$scope.statuses = [];
		if(typeof(classif[cfg.classifId]) !== 'undefined'){
			$scope.statuses = classif[cfg.classifId];
		}

		$scope.postElements = {
			status: cfg.status
		};

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			$mdDialog.hide($scope.postElements);
		};
	}


	actPausePaymentDeadline(ev){
		this.pausePaymentDeadline(ev, {
			mandatory: this.cfgPausePaymentDealine?.mandatory,
			dialogTitle: this.cfgPausePaymentDealine?.dialogTitle,
			explain: this.cfgPausePaymentDealine?.explain,
			submitUrl: this.cfgPausePaymentDealine?.submitUrl,
            submitButton: this.cfgPausePaymentDealine?.submitButton
		});
	}

	pausePaymentDeadline(ev, cfg){
		const postElements = {
			subject: this.$filter('tr')('periodic_pause_payment_deadline_subject').replace(/<\/?[^>]+(>|$)/g, ""),
			comment: this.$filter('tr')('periodic_pause_payment_deadline_body').replace(/<\/?[^>]+(>|$)/g, "")
		};
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "$filter", 'postElements', 'cfg', this.commentCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'esfasi/ng_subject_and_comment.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				postElements: postElements,
				cfg: cfg
			}
		}).then((results) => {
			if(cfg.submitUrl){
				this.$scope.basicHttpConfigProcess({
					url: cfg.submitUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}

	commentCtrl($scope,$mdDialog, $filter, postElements, cfg){
		$scope.cfg = cfg;
		$scope.postElements = postElements;
		if(typeof($scope.cfg.dialogTitle) === 'undefined'){
			$scope.cfg.dialogTitle = $filter('tr')('comment_dialog_title');
		}
		if(typeof($scope.cfg.submitButton) === 'undefined'){
			$scope.cfg.submitButton = $filter('tr')('submit_button');
		}

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			$mdDialog.hide($scope.postElements);
		};
	}

	actConfirmLiftSuspension(ev){
		this.$timeout(()=>{
			const confirmTexts = this.jsDataService.get('liftSuspensionConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgLiftSuspenstionPaymentDeadlineUrl'),
					method: 'GET',
					params: {}
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});

		});
	}
}